import script from "./GavetaFiltrosAvancados.vue?vue&type=script&setup=true&lang=js"
export * from "./GavetaFiltrosAvancados.vue?vue&type=script&setup=true&lang=js"

import "./GavetaFiltrosAvancados.vue?vue&type=style&index=0&id=c1f14ed8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1f14ed8"]])

export default __exports__